@if (productRegulations) {
  <div class="table-wrapper">
    <table mat-table [dataSource]="productRegulations.substanceRegulations">
      @for (column of displayedColumns; track column) {
        <ng-container [matColumnDef]="column" [sticky]="isStickyColumn(column)">
          <th mat-header-cell *matHeaderCellDef>{{ getColumnName(column) }}</th>
          <td mat-cell *matCellDef="let substance">
            {{ formatColumnValue(substance[column]) }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="aggregated-row">
            {{ getColumnValueForAggregate(column) }}
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="info" sticky>
        <td mat-footer-cell *matFooterCellDef colspan="8">
          {{ translationService.getLastRowAggregatedResultsText() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      <tr
        mat-footer-row
        *matFooterRowDef="['info']"
        class="info-footer-row"
      ></tr>
    </table>
  </div>
}
